import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m2 8 2 2-2 2 2 2-2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 8-2 2 2 2-2 2 2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "14", x: "8", y: "5", rx: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Vibrate";
const Vibrate = memo(themed(Icon));
export {
  Vibrate
};
//# sourceMappingURL=vibrate.js.map
